import { logger } from '../../util/logger';

export const createOnError = (evid, params) => (error: Error) => {
  logger.error({
    error,
    message: `Fail to send bi event. Evid:${evid}`,
    callParams: params,
  });
};
